import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { ActiveTimeseriesResponse } from "@src/types/timeseries";

export interface GetActiveTimeseriesResult {
  success: boolean;
  data?: ActiveTimeseriesResponse;
  error?: string;
}

export const getActiveTimeseriesUseCase = async (
  sourceId: string,
): Promise<GetActiveTimeseriesResult> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getActiveTimeseries({
      namespace,
      sourceId,
    });

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch active timeseries")
        .message,
    };
  }
};
